module.exports = __webpack_public_path__ + "static/img/djkx3.2cf0e57.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/djkx3.jpeg
// module id = gH9+
// module chunks = 1